import { ListingSellerDraftModel } from '@steelbuy/ts-shared';

import { ListingSellerDraftEntityData } from './ListingSellerDraftEntityData';
import { useEntityData } from '../../util/consumer/EntityConsumerHook';

export const useListingSellerDraftEntityData = () =>
    useEntityData<ListingSellerDraftModel>(ListingSellerDraftEntityData);
